import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconVisibilityOffSvg } from "./IconVisibilityOffSvg.mjs";
const IconVisibilityOff = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconVisibilityOffSvg, ...iconProps });
};
export {
  IconVisibilityOff
};
